import React, { useState } from "react";
import { useConfig } from "../contexts/ConfigContext";
import logo from "../logo.svg"; // Fallback logo

const Header: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { config } = useConfig();

  // Use the configured color or fall back to default blue
  const bgColor = config?.primaryColor || "#1d4ed8";
  const logoUrl = config?.logoUrl || logo;

  return (
    <header style={{ backgroundColor: bgColor }} className="shadow-md">
      <div className="container mx-auto px-4">
        {/* Desktop Navigation - absolute positioned top right */}
        <nav className="hidden md:block absolute right-8 top-4">
          <ul className="flex space-x-8">
            <li>
              <a
                href="/"
                className="text-white hover:text-opacity-80 font-medium transition-colors"
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="/faq"
                className="text-white hover:text-opacity-80 font-medium transition-colors"
              >
                FAQ
              </a>
            </li>
            <li>
              <a
                href="/contact"
                className="text-white hover:text-opacity-80 font-medium transition-colors"
              >
                Contact
              </a>
            </li>
          </ul>
        </nav>

        {/* Mobile menu button - absolute positioned top right */}
        <div className="md:hidden absolute right-4 top-4">
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="p-2 focus:outline-none text-white hover:bg-opacity-80 rounded"
            aria-label="Toggle menu"
          >
            <svg
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {mobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Centered Logo and Title */}
        <div className="flex flex-col items-center justify-center py-6">
          <div className="bg-white rounded-full p-4 shadow-md flex items-center justify-center mb-4">
            <img
              src={logoUrl}
              alt="Interstate Parking Logo"
              className="h-16 w-16 object-contain"
            />
          </div>
          <div className="text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-white">
              Interstate Parking
            </h1>
            <p className="text-xl text-white text-opacity-90 mt-2">
              Permit Management System
            </p>
          </div>
        </div>

        {/* Mobile Menu - Slides down when open */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-white border-opacity-20">
            <ul className="py-2 space-y-1">
              <li>
                <a
                  href="/"
                  className="block py-2 px-4 text-white hover:bg-opacity-80 transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="/faq"
                  className="block py-2 px-4 text-white hover:bg-opacity-80 transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  FAQ
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="block py-2 px-4 text-white hover:bg-opacity-80 transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
